import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project imports
import { APP_DEFAULT_PATH } from 'config';
import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'types/auth';

// ==============================|| GUEST GUARD ||============================== //

export default function GuestGuard({ children }: GuardProps) {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    // Auth pages that logged-in users ARE allowed to access,
    // because they are part of the mandatory security flow
    const allowedForLoggedIn = ['/verify-email', '/setup-2fa'];

    const isAllowedWhileLoggedIn = allowedForLoggedIn.some((p) => path.startsWith(p));

    if (isLoggedIn && !isAllowedWhileLoggedIn) {
      navigate(location?.state?.from ? location?.state?.from : APP_DEFAULT_PATH, {
        state: {
          from: ''
        },
        replace: true
      });
    }
  }, [isLoggedIn, navigate, location]);

  return children;
}
